import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SwalAlertService {
  constructor(private router: Router) {}

  showAlert(
    title: string,
    text: string,
    icon: SweetAlertIcon,
    showConfirmButton: boolean = false,
    showCancelButton: boolean = false,
    customOptions?: SweetAlertOptions,
    onConfirm?: () => void
  ): void {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'Ok',
      confirmButtonColor: 'green',
      cancelButtonText: 'Não',
      cancelButtonColor: 'red',
      showConfirmButton,
      showCancelButton,
      ...customOptions
    }).then(result => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      }
    });
  }

  handleError(
    err: any,
    fallbackTitle: string = 'Erro!',
    fallbackMessage: string = 'Ocorreu um erro ao realizar a operação, tente novamente.',
    icon: SweetAlertIcon = 'error'
  ): void {
    if (err?.handled) return;
    this.showAlert(fallbackTitle, fallbackMessage, icon);
  }

  showConfirmWithTextarea(
    title: string,
    text: string,
    inputLabel: string,
    inputPlaceholder: string,
    onConfirm: (value: string) => void,
    icon: SweetAlertIcon = 'warning'
  ): void {
    Swal.fire({
      title,
      text,
      icon,
      input: 'textarea',
      inputLabel,
      inputPlaceholder,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: 'green',
      cancelButtonColor: 'red',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        const input = Swal.getInput() as HTMLTextAreaElement | null;
        if (!confirmButton || !input) return;

        confirmButton.disabled = true;

        const syncConfirmButton = () => {
          confirmButton.disabled = !input.value.trim();
        };

        input.addEventListener('input', syncConfirmButton);
      },
      inputValidator: (value) => {
        if (!value?.trim()) {
          return 'Informe o motivo do cancelamento';
        }
        return null;
      }
    }).then(result => {
      if (result.isConfirmed && result.value) {
        onConfirm(String(result.value).trim());
      }
    });
  }

  showAlertOnConfirmNavigate(
    title: string,
    text: string,
    icon: SweetAlertIcon,
    route: string,
    showConfirmButton: boolean = false,
    customOptions?: SweetAlertOptions
  ): void {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'Ok',
      confirmButtonColor: 'green',
      cancelButtonText: 'Não',
      cancelButtonColor: 'red',
      showConfirmButton,
      ...customOptions
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate([route]);
      }
    });
  }
}
